<template>
	<div class="job_detail">
		<div class="jdl_pc" v-if="!isPhone">
			<div class="pd_tit">{{ detail.title }}</div>
			<zihao v-if="detail.addtime" :atime="detail.addtime" @font-size="fontSize"></zihao>
			<div class="job_info img_auto" :style="{ fontSize: zihao + 'px !important',backgroundColor: bgcolor }" v-html="detail.content"></div>
			<div class="pdf_box" v-if="fileArr.length">
				<div class="mt_10" v-for="(item,index) in fileArr" :key="index">
					<vue-office-pdf v-if="item.type=='pdf'" :src="item.src" />
					<!-- <vue-office-docx v-if="item.type=='docx'" :src="item.src" /> -->
				</div>
			</div>
			<div class="fj_box">
				<div class="fj_item flex3" v-for="(item,index) in fileArr" :key="index">
					<span>附件{{index+1}}：{{item.name}}</span>
					<span class="ml_15" @click="yuLan(item)">预览</span>
					<span class="ml_15" @click="xiaZai(item)">下载</span>
				</div>
			</div>
            <upnext :updata="updata" :nextdata="nextdata" atpage="jobdetail"></upnext>
		</div>
		<div class="jdl_ph" v-if="isPhone">
			<div class="pd_tit">{{ detail.title }}</div>
			<div style="padding: 0 0.35rem;">
				<zihao v-if="detail.addtime" :atime="detail.addtime"
					@font-size="fontSize"></zihao>
			</div>
			<div class="job_info" :style="{ fontSize: zihao2 + 'rem !important',backgroundColor: bgcolor }" v-html="detail.content"></div>
			<div class="pdf_box" v-if="fileArr.length">
				<div class="mt_10" v-for="(item,index) in fileArr" :key="index">
					<vue-office-pdf v-if="item.type=='pdf'" :src="item.src" />
					<!-- <vue-office-docx v-if="item.type=='docx'" :src="item.src" /> -->
				</div>
			</div>
			<div class="fj_box" v-if="fileArr.length">
				<div class="fj_item flex3" v-for="(item,index) in fileArr" :key="index" style="align-items: flex-start;">
					<span>附件{{index+1}}：{{item.name}}</span>
					<span class="ml_15" style="width: 1rem;" @click="yuLan(item)">预览</span>
					<span class="ml_15" style="width: 1rem;" @click="xiaZai(item)">下载</span>
				</div>
			</div>
            <upnext :updata="updata" :nextdata="nextdata" atpage="jobdetail"></upnext>
		</div>
	</div>
</template>

<script>
import VueOfficePdf from '@vue-office/pdf';
import VueOfficeDocx from '@vue-office/docx';
export default {
	components: {
		VueOfficePdf,
		VueOfficeDocx,
	},
	data() {
		return {
			id: '',
			detail: {},
			notes: {},
			staticImg: this.$staticImg,
			isPhone: this.$isMobile,
			fileArr: [],
			zihao: 16,
			zihao2: 0.39,
            updata: {},
			nextdata: {},
            bgcolor:'#fcfcfc',
		}
	},
    watch: {
		$route(to, from) {
			if (to.path == "/joinUs/jobDetail") {
				this.detail = {};
				this.updata = {};
				this.nextdata = {};
				this.id = this.$route.query.id;
                this.fileArr = [];
				this.hiredt();
			}
		},
	},
	created() {
		this.id = this.$route.query.id;
        this.fileArr = [];
		this.hiredt();
		this.signup();
	},
	methods: {
		// 报名须知
		async signup() {
			const res = await this.$api.signup();
			if (res.code == 1) {
				this.notes = res.data;
			}
		},
		fontSize(e) {
			if (this.isPhone) {
				this.zihao2 = e;
			} else {
				this.zihao = e;
			}
		},
		// 招聘详情
		async hiredt() {
			const res = await this.$api.hiredt({
				id: this.id
			});
            // console.log('招聘详情',res)
			if (res.code == 1) {
				this.detail = res.data.mess;
                this.updata = res.data.up;
				this.nextdata = res.data.next;
                this.detail.content = this.detail.content.replace(
					/<img[^>]*src=['"]([^'"]*)['"][^>]*>/g,
					match => match.replace(/(<img)/, '$1 referrerpolicy="no-referrer"')
				);
                if(this.detail.color){
                    this.bgcolor = this.detail.color;
                }
				if (this.detail.file) {
					var arr1 = this.detail.file.split(',');
					var arr2 = this.detail.filename.split(',');
					for (let i = 0; i < arr1.length; i++) {
						for (let j = 0; j < arr1.length; j++) {
							if (i == j) {
								this.fileArr.push({
									src: this.$staticImg + arr1[i],
									name: arr2[j],
									type: this.getFileType(arr1[i])
								})
							}
						}
					}
				}
			}
		},
		getFileType(url) {
			const extMatch = url.match(/\.([^./?#]+)(?:[?#]|$)/i);
			const ext = extMatch ? extMatch[1].toLowerCase() : '';
			if (ext === 'pdf') return 'pdf';
			if (ext === 'docx') return 'docx';
			return 'unknown';
		},
		yuLan(item) {
			if (item.type == 'pdf') {
				window.open(item.src, '_blank');
			}
			if (item.type == 'docx') {
				const officeUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(item.src)}`;
				window.open(officeUrl, '_blank', 'width=1920,height=1080');
			}
		},
		xiaZai(item) {
			const fileUrl = item.src;
			const fileName = item.name;
			const link = document.createElement('a');
			link.href = fileUrl;
			link.setAttribute('download', fileName);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
	}
}
</script>

<style lang="scss">
.job_detail {
	.jdl_pc {
		.pd_tit {
			text-align: center;
			font-weight: bold;
			font-size: 24px;
		}
		.bmxz_box {
			background-color: #f9f9f9;
			.bb_left {
				width: 520px;
			}
			.bb_right {
				flex: 1;
				padding: 20px 30px;
				height: 100%;
			}
		}
		.job_name {
			margin-top: 60px;
			height: 60px;
			line-height: 60px;
			background-color: #003f99;
			color: #fff;
			padding: 0 25px;
			border-radius: 10px 10px 0 0;
			font-size: 18px;
		}
		.job_info {
			padding: 30px 20px;
			div {
				font-size: inherit !important;
			}
			p {
				font-size: inherit !important;
			}
			span {
				font-size: inherit !important;
			}
			table {
				tr {
					border: 1px solid #999;
					td {
						border: 1px solid #999;
					}
				}
			}
		}
	}
	.jdl_ph {
		padding: 0.35rem;
		.pd_tit {
			text-align: center;
			font-weight: bold;
			font-size: 24px;
		}
		.bmxz_box {
			background-color: #f9f9f9;
			.bb_left {
				img {
					width: 100%;
				}
			}
			.bb_right {
				padding: 0.4rem;
				height: 100%;
			}
		}
		.job_name {
			margin-top: 0.4rem;
			height: 1.46rem;
			line-height: 1.46rem;
			background-color: #003f99;
			color: #fff;
			padding: 0 0.6rem;
			border-radius: 0.25rem 0.25rem 0 0;
			font-size: 0.43rem;
		}
		.job_info {
			padding: 0.73rem 0;
			div {
				font-size: inherit !important;
			}
			p {
				font-size: inherit !important;
			}
			span {
				font-size: inherit !important;
			}
		}
	}
}
</style>